import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
export interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    properties: { [key: string]: string };
    notes?: string;
    taxExemptionMessage?: string;
    attentionMessage?: string;
}

addToChainBefore(chain, PopulateApiParameter, props => {
    const params = props?.parameter as unknown as PlaceOrderParameter;
    props.cartToUpdate.properties = params?.properties;
});

addToChainBefore(chain, UpdateCart, props => {
    const params = props?.parameter as unknown as PlaceOrderParameter;
    let notesText = "";
    if (typeof params?.taxExemptionMessage !== 'undefined' && params?.taxExemptionMessage !== "") {
        notesText += params?.taxExemptionMessage;
    }
    if (typeof params?.attentionMessage !== 'undefined' && params?.attentionMessage !== "") {
        notesText += params?.attentionMessage;
    }
    if (typeof params?.notes !== 'undefined') {
        notesText += params?.notes;
    }
    // Flag orders that proceeded on an address the customer chose to keep unverified (Piyovi AVS),
    // so CS can manually review. Flows to ERP via cart.notes -> SxtInOrderV4.Notes.
    const keptUnverifiedAddress =
        typeof props.getState === "function"
            ? (props.getState() as any)?.customCheckoutShippingState?.keptUnverifiedAddress
            : false;
    if (keptUnverifiedAddress) {
        const avsNote = "Address not verified by AVS - manual review required.";
        if (!notesText.includes(avsNote)) {
            notesText += (notesText !== "" ? " " : "") + avsNote;
        }
    }
    if (notesText !== "") {
        props.apiParameter.cart.notes = notesText;
    }
});